module.exports = "/_next/static/images/1b9474d4d5689d57602c1e8fde1fc82f-2-cards@1x.jpg";